export const SALE_DETAIL_REPORT_LIST_INITING = 'SALE_DETAIL_REPORT_LIST_INITING'
export const SALE_DETAIL_REPORT_LIST_REQUESTING = 'SALE_DETAIL_REPORT_LIST_REQUESTING'
export const SALE_DETAIL_REPORT_LIST_SUCCESS = 'SALE_DETAIL_REPORT_LIST_SUCCESS'
export const SALE_DETAIL_REPORT_LIST_ERROR = 'SALE_DETAIL_REPORT_LIST_ERROR'

export const SALE_DETAIL_REPORT_NVKD_REQUESTING = 'SALE_DETAIL_REPORT_NVKD_REQUESTING'
export const SALE_DETAIL_REPORT_NVKD_SUCCESS = 'SALE_DETAIL_REPORT_NVKD_SUCCESS'
export const SALE_DETAIL_REPORT_NVKD_ERROR = 'SALE_DETAIL_REPORT_NVKD_ERROR'

export const SALE_DETAIL_REPORT_KH_REQUESTING = 'SALE_DETAIL_REPORT_KH_REQUESTING'
export const SALE_DETAIL_REPORT_KH_SUCCESS = 'SALE_DETAIL_REPORT_KH_SUCCESS'
export const SALE_DETAIL_REPORT_KH_ERROR = 'SALE_DETAIL_REPORT_KH_ERROR'

export const SALE_DETAIL_REPORT_KHOXUAT_REQUESTING = 'SALE_DETAIL_REPORT_KHOXUAT_REQUESTING'
export const SALE_DETAIL_REPORT_KHOXUAT_SUCCESS = 'SALE_DETAIL_REPORT_KHOXUAT_SUCCESS'
export const SALE_DETAIL_REPORT_KHOXUAT_ERROR = 'SALE_DETAIL_REPORT_KHOXUAT_ERROR'

export const SALE_DETAIL_REPORT_EXPORT_XLS_REQUESTING = 'SALE_DETAIL_REPORT_EXPORT_XLS_REQUESTING'
export const SALE_DETAIL_REPORT_EXPORT_XLS_SUCCESS = 'SALE_DETAIL_REPORT_EXPORT_XLS_SUCCESS'
export const SALE_DETAIL_REPORT_EXPORT_XLS_ERROR = 'SALE_DETAIL_REPORT_EXPORT_XLS_ERROR'

export const SALE_DETAIL_REPORT_NVKD_API = '/api/v1/users/get_list_by_quanly'
export const SALE_DETAIL_REPORT_KH_API = '/api/v1/khachhang/KhachByNvkd'
export const SALE_DETAIL_REPORT_KHOXUAT_API = '/api/v1/kho/getKhoAllOfUser'
export const SALE_DETAIL_REPORT_LIST_API = '/api/v1/report/baoCaoChiTietBanHang'
export const SALE_DETAIL_REPORT_EXPORT_XLS_API = '/api/v1/report/bao_cao_chi_tiet_export_by_store' 


// WEBPACK FOOTER //
// ./src/views/Reports/SaleDetailReport/constants.js